import { render, staticRenderFns } from "./documentRequestDetailCorporation.vue?vue&type=template&id=39f5ebb4&scoped=true&"
import script from "./documentRequestDetailCorporation.vue?vue&type=script&lang=js&"
export * from "./documentRequestDetailCorporation.vue?vue&type=script&lang=js&"
import style0 from "./documentRequestDetailCorporation.vue?vue&type=style&index=0&id=39f5ebb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f5ebb4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCard,VCol,VDialog,VIcon,VRow,VSelect,VTextarea})
